const routes = [
    {
        path: "/login/logs",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "log_loginlog"
        }
    },
];

export default routes;
